import { SKILLS, SKILL_META } from "@/lib/game";
import { formatStatTitle } from "@/lib/statTitles";

const MAX_SKILL = 1000;

export function StatBars({ skills, skillTitles, compact }) {
  const highestSkill = Math.max(MAX_SKILL, ...SKILLS.map((skill) => Number(skills?.[skill] || 0)));
  const barMax = highestSkill > MAX_SKILL ? Math.ceil(highestSkill / 100) * 100 : MAX_SKILL;
  return (
    <div className={compact ? "space-y-1.5" : "space-y-2.5"}>
      {barMax > MAX_SKILL && (
        <div data-testid="stat-bars-scale" className="text-[9px] uppercase tracking-widest text-amber-400/80">
          Bar scale: 0–{barMax.toLocaleString()}
        </div>
      )}
      {SKILLS.map((s) => {
        const meta = SKILL_META[s];
        const val = skills?.[s] ?? 0;
        const pct = Math.min(100, (val / barMax) * 100);
        const title = skillTitles?.[s]?.title;
        const level = skillTitles?.[s]?.level || (typeof skillTitles?.[s]?.index === "number" ? skillTitles[s].index + 1 : undefined);
        return (
          <div key={s} data-testid={`stat-${s}`}>
            <div className="flex justify-between text-[11px] text-zinc-400 mb-1 font-manrope font-medium uppercase tracking-wider">
              <span className="flex items-center gap-1.5"><meta.icon size={11} className="opacity-70" />{meta.label}</span>
              <span className="text-zinc-300 tabular-nums inline-flex flex-wrap items-baseline justify-end gap-x-1 max-w-[12rem] text-right">
                <span data-testid={`stat-value-${s}`}>{val}</span>
                {title && <span data-testid={`stat-title-${s}`} className="text-zinc-500 normal-case tracking-normal">{formatStatTitle(title, level)}</span>}
              </span>
            </div>
            <div data-testid={`stat-bar-${s}`} className="w-full h-1.5 bg-zinc-800/80 overflow-hidden border-b border-white/5">
              <div className={`${meta.color} h-full transition-all duration-500`} style={{ width: `${pct}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
